<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th><input type="checkbox" :checked="selectAll" @change="toggleAll"></th>

        <th @click="handleSort('name')" class="sortable-header">
          {{ $t('name_payment') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('name')"
          >
        </th>

        <th @click="handleSort('status')" class="sortable-header">
          {{ $t('status_payment_title') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('status')"
          >
        </th>

        <th @click="handleSort('addedDate')" class="sortable-header">
          {{ $t('added_date') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('addedDate')"
          >
        </th>

        <th @click="handleSort('programsCount')" class="sortable-header">
          {{ $t('total_programs_tab') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('programsCount')"
          >
        </th>

        <th @click="handleSort('email')" class="sortable-header">
          {{ $t('email_address') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('email')"
          >
        </th>

        <th @click="handleSort('phoneNumber')" class="sortable-header">
          {{ $t('phone_number_person') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('phoneNumber')"
          >
        </th>

        <th @click="handleSort('department')" class="sortable-header">
          {{ $t('user_department_name') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('department')"
          >
        </th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="user in users" :key="user.userId">
        <td class="td-style"><input type="checkbox" @change="(e) => toggleUser(e, user.userId)"
                                    :checked="selectedUserIds.includes(user.userId)"></td>

        <td class="td-style">
          <router-link :to="'/users/detail/' + user.userId" class="name-row">
            <template v-if="user.avatarUrl">
              <img class="company-icon" :src="user.avatarUrl"/>
            </template>
            <template v-else>
              <em class="no-data-text">{{ $t('no_data') }}</em>
            </template>
            <template v-if="user.name || user.surname">
              <span class="test-class">{{ truncateText(user.name + ' ' + user.surname, 20) }}</span>
            </template>
            <template v-else>
              <em class="no-data-text">N/A</em>
            </template>
          </router-link>
        </td>

        <td class="td-style">
            <span class="test-class">
              <img v-if="user.status=== true" src="@/assets/images/active.svg">
              <img v-else src="@/assets/images/failed.svg">
              <span v-if="user.status" class="status-text">
                {{ $t('active') }}
              </span>
              <span v-else class="status-text">
                {{ $t('inactive') }}
              </span>
              <button
                  v-if="!user.status && !user.invitedStatus && user.isInvitationExpired"
                  class="resend-invite-btn"
                  @click.stop="resendInvite(user)"
                  :disabled="resendingUserId === user.userId"
              >
                {{ resendingUserId === user.userId ? $t('sending') : $t('resend_invite') }}
              </button>
            </span>
        </td>

        <td class="td-style">
            <span class="test-class">
              <img src="../../../assets/images/datepicker.svg">
              {{ truncateText(user.addedDate, 10) }}
            </span>
        </td>

        <td class="td-style">
            <span class="test-class">
              <img src="../../../assets/images/programs.svg">
              {{ truncateText($t('program_count', {programCount: user.programsCount}), 10) }}
            </span>
        </td>

        <td class="td-style">
          <span class="test-class">{{ truncateText(user.email, 20) }}</span>
        </td>

        <td class="td-style">
          <template v-if="user.phoneNumber">
            <span class="test-class">{{ truncateText(user.phoneNumber, 15) }}</span>
          </template>
          <template v-else>
            <em class="no-data-text">N/A</em>
          </template>
        </td>

        <td class="td-style">
          <template v-if="user.departments && user.departments.length > 0">
           <span class="test-class" v-for="(department, index) in user.departments" :key="department.id">
            {{ truncateText(department.name, 15) }}
              <span v-if="index < user.departments.length - 1">, </span>
           </span>
          </template>
          <template v-else>
            <em class="no-data-text">N/A</em>
          </template>
        </td>
      </tr>

      <tr v-else>
        <td colspan="8" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c"/>
          <span class="text">{{ $t('loading') }}</span>
        </td>
      </tr>

      <tr v-if="!loading && users.length === 0 ">
        <td colspan="8" class="table-loading">
          <span class="text">{{ $t('no_data_found') }}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import {VueSpinner} from "vue3-spinners";
import UserFilters from "@/components/tables/User/UserFilters.vue";
import companyService from "@/service/companyService";
import commonService from "@/service/commonService";
import inviteService from "@/service/inviteService";
import userService from "@/service/userService";
import {handleErrorResponse} from "@/utils/utils";
import ActionDropdown from "@/components/ActionDropdown.vue";

export default {
  components: {
    UserFilters,
    AddUserModal,
    ExpandableSearch,
    VueSpinner,
    ActionDropdown
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    addNewUser: {
      type: Function,
      default: () => {
      }
    },
    users: {
      type: Array,
      required: true
    },
    rightAction: {
      type: Boolean,
      default: true
    },
    companyId: {
      type: Number,
      default: null
    },
    code: {
      type: Number,
      default: null
    },
    refreshData: {
      type: Function,
      default: () => {
      }
    },
    currentSort: {
      type: Object,
      default: () => ({ column: null, direction: null })
    },
    onSort: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      inviteCode: null,
      showModal: false,
      selectAll: false,
      showFilter: false,
      searchText: '',
      selectedUserIds: [],
      departmentList: [],
      departmentActions: [],
      isProcessing: false,
      resendingUserId: null
    }
  },
  created() {
    this.inviteCode = this.code;
    this.loadDepartments();
  },
  methods: {
    handleSort(column) {
      let newDirection = 'asc';

      if (this.currentSort.column === column) {
        if (this.currentSort.direction === 'asc') {
          newDirection = 'desc';
        } else if (this.currentSort.direction === 'desc') {

          this.onSort(null, null);
          return;
        }
      }

      this.onSort(column, newDirection);
    },

    getSortClass(column) {
      if (this.currentSort.column !== column) {
        return 'sort-default';
      }

      if (this.currentSort.direction === 'asc') {
        return 'sort-asc';
      } else if (this.currentSort.direction === 'desc') {
        return 'sort-desc';
      }

      return 'sort-default';
    },

    getSortIcon(column) {
      const statusIcon = '../../../assets/images/status.svg';

      if (this.currentSort.column !== column) {
        return statusIcon;
      }

      if (this.currentSort.direction === 'asc') {
        return statusIcon;
      } else if (this.currentSort.direction === 'desc') {
        return statusIcon;
      }

      return statusIcon;
    },

    loadDepartments() {
      commonService.getDepartments().then(response => {
        this.departmentList = response.data.data.departments.filter(department =>
            department.name && department.name.trim() !== ''
        );

        this.departmentActions = this.departmentList.map(dept => ({
          name: dept.name,
          action: dept.id.toString()
        }));

      }).catch(err => {
        handleErrorResponse(err, this.$snackbar);
      });
    },
    toggleAll() {
      this.selectAll = !this.selectAll;
      if (this.selectAll) {
        this.selectedUserIds = this.users.map(user => user.userId);
      } else {
        this.selectedUserIds = [];
      }
    },
    toggleUser(e, userId) {
      if (e.target.checked) {
        this.selectedUserIds.push(userId);
      } else {
        this.selectedUserIds = this.selectedUserIds.filter(id => id !== userId);
      }
    },
    handleSearch(event) {
      this.searchText = event.target.value;
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    handleDepartmentAction(action) {
      if (!action || !this.selectedUserIds.length || this.isProcessing) {
        return;
      }

      this.isProcessing = true;

      const departmentId = action;

      this.assignDepartmentToUsers(departmentId);
    },
    assignDepartmentToUsers(departmentId) {
      const department = this.departmentList.find(dept => dept.id.toString() === departmentId);

      userService.assignDepartmentToUsers(this.selectedUserIds, departmentId)
          .then((response) => {

            this.$snackbar.add({
              text: `${this.selectedUserIds.length} kullanıcı ${department ? department.name : ''} kullanıcı grubuna atandı`,
              type: 'success'
            });

            this.selectedUserIds = [];
            this.selectAll = false;
            this.refreshData();
          })
          .catch(err => {
            handleErrorResponse(err, this.$snackbar);
          })
          .finally(() => {
            this.isProcessing = false;
          });
    },
    resendInvite(user) {
      this.resendingUserId = user.userId;
      inviteService.resendInvite(user.userId)
          .then(() => {
            this.$snackbar.add({
              text: this.$t('invite_resent_success'),
              type: 'success'
            });
            user.isInvitationExpired = false;
          })
          .catch(err => {
            handleErrorResponse(err, this.$snackbar);
          })
          .finally(() => {
            this.resendingUserId = null;
          });
    }
  }
}
</script>

<style>
.resend-invite-btn {
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 11px;
  background-color: #ff9800;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.resend-invite-btn:hover {
  background-color: #f57c00;
}
.resend-invite-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sortable-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #f5f5f5;
}

.sort-icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: middle;
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: inline-block;
  opacity: 0.4; /* Pasif kolonlar için soluk */
}

/* Hover'da biraz belirginleştir */
.sortable-header:hover .sort-icon {
  opacity: 0.6;
}

/* Aktif sıralama - tam görünür */
.sort-icon.sort-asc,
.sort-icon.sort-desc {
  opacity: 1;
}

/* ASC - Normal (yukarı) */
.sort-icon.sort-asc {
  transform: rotate(0deg);
}

/* DESC - 180 derece dönmüş (aşağı) */
.sort-icon.sort-desc {
  transform: rotate(360deg);
}

/* Varsayılan durum - hafif görünür */
.sort-icon.sort-default {
  transform: rotate(0deg);
  opacity: 0.4;
}

.bottom-user-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  margin-top: 8px;
}

.selected-label {
  margin-right: 16px;
  font-size: 14px;
  color: #6b7280;
}

.flex-row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
}

.row-item {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
  background-color: #f2f2f2;
  position: relative;
  cursor: pointer;
}

.row-item.filter {
  background-color: transparent;
}

.row-item-txt {
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  font-weight: 500;
  font-style: normal;
  white-space: nowrap;
}

.filter-view {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  min-height: 52px;
}

.justify-end-div {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: center;
}

.justify-end-search {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
}

.company-icon {
  height: 32px;
  width: 32px;
  border-radius: 50%;
}

.show-filters {
  font-family: euclid_medium, sans-serif;
  color: #4A68F8;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
}

.row-item-icon {
  height: 16px;
  width: 16px;
}

.name-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span {
  color: #4A68F8;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.company-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ddd;
}

.no-data-text {
  font-style: italic;
  color: #B6C1DB;
  font-size: 12px;
  font-weight: bold;
}

.td-style {
  align-content: center;
  text-align: left !important;
}
</style>
